import React, { Component } from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css" // requires a loader
import { Carousel } from "react-responsive-carousel"
import "@brainhubeu/react-carousel/lib/style.css"
import { Link, graphql, StaticQuery } from "gatsby"
import {IoMdArrowDropdown} from "react-icons/io"
import "../Styles/index.scss"
import Img from "gatsby-image"

const leftsliderquery = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        children: {}
        frontmatter: { cat: { eq: "blog" }, slider: { eq: true } }
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            cat
            image {
              publicURL
            }
          }
          excerpt(truncate: true)
          fields {
            slug
          }
        }
      }
    }
  }
`

export default class MyCarousel extends React.Component {
  render() { 
    return (
      <div className="right-slider">
        <StaticQuery
          query={leftsliderquery}
          render={data => {
            return (
              <div>
                <Carousel autoPlay interval="5000" transitionTime="1000" style={{height:"100%"}}>
                  {data.allMarkdownRemark.edges.map(({ node }) => (
                    <div>
                       
                      <img
                        src={node.frontmatter.image.publicURL}
                        alt="first slide"
                      /><Link to={node.fields.slug}>
                      <h1 className="legend">{node.frontmatter.title}</h1></Link>
                    </div>
                  ))}
                </Carousel>
                <Link to="/blog">

                
                <div className="more-btn" >
                <ul>
                <li>
                more
                </li>
                <li>
                <IoMdArrowDropdown />
                </li>
                </ul>
                
                </div></Link>
              </div>
            )
          }}
        />

        {/* <div>
                        <img src="https://picsum.photos/700/400?img=1" />
                        <p className="legend">My Classic Still 1</p>
                    </div>
                    <div>
                        <img src="https://picsum.photos/700/400?img=2" />
                        <p className="legend">My Classic Still 2</p>
                    </div>
                    <div>
                        <img src="https://picsum.photos/700/400?img=3" />
                        <p className="legend">My Classic Still 3</p>
                    </div> */}

        <div></div>
      </div>
      //     <Carousel
      //       value={this.state.value}
      //       slides={this.state.slides}
      //       onChange={this.onchange}
      //       autoPlay={5000}
      // animationSpeed={1000}
      // infinite
      //     />
      //     <br/>
      //     <Dots number={this.state.thumbnails.length} thumbnails={this.state.thumbnails} value={this.state.value} onChange={this.onchange} number={this.state.slides.length} />
    )
  }
}
